import React, { useEffect, useState, useRef } from 'react'; 
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import SideMenu from './SideMenu';
import OndeEstou from './OndeEstou';
import { Card } from 'primereact/card';
import { Badge } from 'primereact/badge';
import BotaoFiltro from '../../Componentes/BotaoFiltro';
import { Tooltip } from 'primereact/tooltip';
import { useNavigate } from 'react-router-dom';  // Importar useNavigate
import { useSessionStorage } from 'primereact/hooks';
import { Toast } from 'primereact/toast';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import BotaoSelectEmpresa from './BotaoSelectEmpresa';
import MenuLateral from './MenuLateral';
import CustonSideMenu from './CustonSideMenu';
import layoutV2 from '../../LayoutV2/LayoutV2';
//https://www.instagram.com/jusplainwinnin_/?fbclid=IwY2xjawJP-ChleHRuA2FlbQIxMAABHY89jcyu18SXQDuOq3DXy6jh3lU9lbVpdLHVn0lwrlXSZcuEGgP-6AH0Jg_aem_Pk8jRp5pfLK11YUCW06e9g
export default function MenuSuspenso(props) {
    const [darkMode, setDarkMode] = useState(true); // Controle de tema
    const [sidebarVisible, setSidebarVisible] = useState(true); // Controle de visibilidade da Sidebar
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const {
        userName,
        tipoAcesso,
        empresa,
        dataEmpresa,
        dataBase,
        habilitarcollector,
        habilitarinventory,
        showMessage, 
        setLoading
      } = props || {};


    const disabledItemMenu = tipoAcesso === 'CLIENTE';

    const toast = useRef(null);

    const navigate = useNavigate();  // Hook para navegação

    const accept = () => {
       // showMessage('Aguarde... processando', 'info')
       setLoading(true)
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('habilitarcollector');
        sessionStorage.removeItem('habilitarinventory');
        sessionStorage.removeItem('BarenToken');
        sessionStorage.removeItem('empresas');
        sessionStorage.removeItem('dataEmpresa')
        setTimeout(()=>{
            setLoading(false)
            navigate('/');
        }, 1000)
    }

    const showConfirm = () => {
        confirmDialog({
            message: 'Tem certeza de que deseja sair?',
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: accept,
            reject: () => console.log('Logout cancelado'),
        });
    };



    

    useEffect(() => {
        // Função que será chamada quando o tamanho da janela mudar
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        // Adiciona o listener de resize
        window.addEventListener('resize', handleResize);

        // Limpeza do evento quando o componente for desmontado
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Lógica para verificar se a tela é menor que o tamanho de um tablet
    const isMobile = windowWidth <= 768; // Menor ou igual a 768px

    const { visible, setVisible } = props;

    // Função para alternar entre os temas
    const toggleDarkMode = () => {
       // //setDarkMode(!darkMode);
       // document.body.classList.toggle('dark-theme'); // Alterna a classe no <body>
    };

    // Chama toggleDarkMode uma vez na montagem
    useEffect(() => {
       // toggleDarkMode();
    }, []);

    const items = [
        { label: 'Dashboard', 
            icon: 'pi pi-chart-line', 
            command: () => {
                navigate('/installation');
            } 
        },
        { label: 'Empresas', icon: 'pi pi-building-columns', 
            disabled : disabledItemMenu, 
            command: () => {
                if (disabledItemMenu) return; // 🔒 Impede navegação
                navigate('/empresas',{state : { 
                    dataEmpresa : dataEmpresa
                }});
            } 
        },
        { label: 'Usuários', icon: 'pi pi-user-plus', 
            command: () => {
                navigate('/installation');
            } 
         },
        { label: 'Clientes', icon: 'pi pi-users', 
            command: () => {
                navigate('/installation');
            } 
         },
        {
            label: 'Collector',
            icon: 'pi pi-sitemap',
            items: [
                { label: 'Licenças', icon: 'pi pi-key', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'DCAs', icon: 'pi pi-share-alt', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
            ],
        },
        {
            label: 'Equipamentos',
            icon: 'pi pi-print',
            items: [
                { label: 'Descobertas', icon: 'pi pi-folder-open' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
                { label: 'Parque', icon: 'pi pi-th-large' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
                { label: 'Sem Conexão', icon: 'pi pi-times-circle', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Desabilitados', icon: 'pi pi-times', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Alertas Toner', icon: 'pi pi-bell', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Trocas Toner', icon: 'pi pi-replay' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
                { label: 'Trocas Peças', icon: 'pi pi-history', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Alertas Manutenção', icon: 'pi pi-wrench', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Atolamentos', icon: 'pi pi-sort-alt-slash' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
            ],
        },
        { label: 'Computadores', icon: 'pi pi-microchip', 
            command: () => {
                navigate('/installation');
            } 
         },
        {
            label: 'Relatórios',
            icon: 'pi pi-receipt',
            items: [
                { label: 'Meus Dados', icon: 'pi pi-bolt', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Cad. Empresas', icon: 'pi pi-server' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
                { label: 'UI Kit', icon: 'pi pi-pencil', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
            ],
        },
        {
            label: 'Downloads',
            icon: 'pi pi-cloud-download',
            items: [
                { label: 'Meus Dados', icon: 'pi pi-bolt', 
                    command: () => {
                        navigate('/installation');
                    } 
                 },
                { label: 'Cad. Empresas', icon: 'pi pi-server' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
                { label: 'UI Kit', icon: 'pi pi-pencil' , 
                    command: () => {
                        navigate('/installation');
                    } 
                },
            ],
        },
        { label: 'Sair', 
            icon: 'pi pi-sign-out', 
            command: () => {
                console.log('sair')
                confirmDialog({
                        message: 'Tem certeza de que deseja sair?',
                        header: 'Confirmação',
                        icon: 'pi pi-exclamation-triangle',
                        acceptLabel: 'Sim',
                        rejectLabel: 'Não',
                        accept: () => console.log('Logout cancelado'),
                        reject: () => console.log('Logout cancelado'),
                    });
            } 
        },
        // Outros itens de menu...
    ];

    const end = (
        <div>
           
            <div className="flex justify-around gap-6" style={{ paddingRight: '25px', paddingTop: '5px', paddingBottom : '6px', }}>
                {/* Ícone de Notificação (Bell) com Badge */}
                <div className="relative">
                    <i className="custom-target-icon pi pi-bell p-text-secondary p-overlay-badge"
                        data-pr-tooltip="No notifications"
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        style={{ fontSize: '1.3rem', cursor: 'pointer' }}>
                        <Badge severity="warning" value={null}></Badge>
                    </i>
                </div>

                {/* Ícone de Calendário com Badge */}
                <div className="relative">
                    <i className="custom-target-icon pi pi-wrench p-text-secondary p-overlay-badge"
                        data-pr-tooltip="No notifications"
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        style={{ fontSize: '1.3rem', cursor: 'pointer' }}>
                        <Badge severity="danger" value={null}></Badge>
                    </i>
                    
                </div>

                {/* Ícone de Mensagem com Badge */}
                <div className="relative">
                    <i className="custom-target-icon pi pi-comments p-text-secondary p-overlay-badge"
                        data-pr-tooltip="No notifications"
                        data-pr-position="right"
                        data-pr-at="right+5 top"
                        data-pr-my="left center-2"
                        style={{ fontSize: '1.3rem', cursor: 'pointer' }}>
                        <Badge severity="contrast" value={null}></Badge>
                    </i>
                    
                </div>

                {/* Ícone de Configurações (Cog) */}
                <div className="relative">
                    <i className="custom-target-icon pi pi-cog p-text-secondary spin" style={{ fontSize: '1.3rem', cursor : 'pointer',  }} onClick={() => setVisible(!visible)} />
           
                </div>
            </div>
            <div style={{width: '250px'}}>
            <span className="block text-md font-bold truncate">Usuário: {userName}</span>
            <span className="block text-xs truncate">Tipo Acesso: {tipoAcesso}</span>
            </div>



        </div>
    );
    

    return (
        <div >
            {/* Barra Superior Fixa */}
            <Menubar 
                model={isMobile ? items : []}
                setLoading={(op)=>setLoading(op)}
                start={
                    !isMobile && (
                        <div className="flex flex-column p-3" >
                        {/* Primeira linha: Ícone e Nome da Empresa */}
                            <div className="flex flex-row items-center gap-3">
                                {/* Ícone dentro de uma div */}
                                <div>
                                {tipoAcesso =='REVENDA' ?   <BotaoSelectEmpresa 
                                        disabledItemMenu
                                        dataEmpresa = {dataEmpresa}
                                        icon="pi pi-cog" 
                                        className="p-button-rounded p-button-text text-blue-900 text-3xl"
                                        style={{fontSize : '61px'}}                            
                                    /> : null}
                                </div>

                                {/* Nome da Revenda e Empresa em outra div */}
                                <div className="flex flex-column">
                                    <span className="block text-lg font-bold truncate">{tipoAcesso}: {dataEmpresa.revenda}</span>
                                    <span className="block text-xs truncate">EMPRESA: {tipoAcesso =='CLIENTE' ? dataEmpresa.cliente+' ('+dataEmpresa.idcliente+')' :  dataEmpresa.empresa+' ('+dataEmpresa.idempresa+')'}</span>
                                </div>
                                
                            </div>

                            {/* Segunda linha: OndeEstou */}
                            <div className="mt-2">
                                <OndeEstou />
                            </div>
                        </div>

                    )
                }
                end={end} 
                style={{ position: 'fixed', top: 0, left:isMobile ? 0 : 198, right: 0, height: '100px',paddingTop : '10px', paddingBottom : '10px', zIndex: 2, borderRadius : '0px'  }} 
/>



            {/* Layout com Flexbox para o menu abaixo da barra */}
          
                {/* Exibe a Sidebar apenas em telas maiores que 768px */}
                {!isMobile && (
                    <SideMenu 
                        {...props}
                        visible={sidebarVisible} 
                        setLoading={(op) => setLoading(op)}
                        modal={false}
                        setVisible={() => setSidebarVisible(false)} 
                        position="left" 
                        className="w-13rem" 
                        showMessage={(event, severity) => showMessage(event, severity)}
                        closeOnEscape={false}
                        dismissable={false}
                        isMobile={props.isMobile}
                        style={{
                            border: 'none',  // Removendo a borda
                            boxShadow: 'none',
                            borderRight: 'solid 0.5px #e5e5e5',                           
                            transition: 'width 0.3s ease', // Transição suave para animações
                        }}
                        showCloseIcon={false}  // Desabilita o ícone de fechar que aparece no backdrop
                        blockScroll={false}    // Desabilita o bloqueio de scroll no fundo
                    />
                

                )}

          
            </div>
    );
}
